import React from "react";
import { Popover, Icon } from "antd";
import PropTypes from "prop-types";

const EmailVerificationReason = ({ style }) => {
  return (
    <div style={style}>
      <Popover
        placement={"bottom"}
        content={
          <p style={{ width: "300px" }}>
            We require users to verify their work email address at least every 9
            months to ensure that they still have access to the company email
            address.
          </p>
        }
        //title={"Email verification process"}
      >
        <p style={{ color: "#999", marginBottom: "0" }}>
          {" "}
          <Icon type={"question-circle-o"} /> Why we ask for email verification?
        </p>
      </Popover>
    </div>
  );
};

EmailVerificationReason.propTypes = {
  style: PropTypes.object
};

export default EmailVerificationReason;



// WEBPACK FOOTER //
// ./src/components/email_verification_reason/EmailVerificationReason.jsx